import { FilterMeta, FilterMetadata, DataType } from './types';
import { isBlank, isNumeric, LastDateType, formatDate } from '../../common/utils';
//import { filter } from 'minimatch';
import { GeneralFilter } from 'src/app/shared/models/Common/common-filter';
import { rsltTypeInAPICall } from 'src/app/shared/functions/title';
//import { RatingOperator } from 'src/app/shared/models/MAINFILTER';

export enum FilterOperator {
  EQUALS = 'equals', // ==
  NOT_EQUAL = 'notEqual', // !=
  LESS_THAN = 'lessThan', // <
  LESS_THAN_OR_EQUAL = 'lessThanOrEqual', // <=
  GREATER_THAN = 'greaterThan', // >
  GREATER_THAN_OR_EQUAL = 'greaterThanOrEqual', // >=
  IN_RANGE = 'inRange', // 3-7
  IN = 'in', // in
  CONTAINS = 'contains', // like lower(%val%);
  NOT_CONTAINS = 'notContains', // not like lower(%val%);
  STARTS_WITH = 'startsWith', // like val%;
  ENDS_WITH = 'endsWith', // like %val;
  IS_EMPTY = 'isEmpty', // is null
  IS_NOT_EMPTY = 'isNotEmpty', // is not null
}

export class DataFilter {

  filters: FilterMetadata = {} as FilterMetadata;
  globalFilterValue: string = null;

  //IMP to filter rows in a page's data
  filterRows(data: any[], rsltType?: string) {
    const filters = this.filters;
    let filteredRows: any[] = data;
    //console.log(filteredRows);
    for (const key in filters) {
      //debugger
    //console.log(filters[key]);
      if (filters[key]) {
        if (this.filters[key].rsltType.indexOf('|') != -1) {//multiple rslt types having same column
          let rsltTypesArr = this.filters[key].rsltType.split('|');
          let boolRsltCheck = false;
          rsltTypesArr.forEach(function (value) {
            //if (key != "VQuad_Timestamp" && rsltTypeInAPICall(value) == rsltType) {
            if (rsltTypeInAPICall(value) == rsltType) {
              boolRsltCheck = true;
              return false;
            }
          });
          //console.log(boolRsltCheck)
          if (boolRsltCheck) {
            filteredRows = filteredRows.filter((row: any) => {
              return (key in row) ? this.compare(row[key], filters[key]) : false;
            });
          }
        }
        else {
          if (this.filters[key].rsltType == "" || rsltTypeInAPICall(this.filters[key].rsltType) == rsltType) {
            filteredRows = filteredRows.filter((row: any) => {
              return (key in row) ? this.compare(row[key], filters[key]) : false;
            });
          }
        }
      }
    }
    filteredRows = this.globalFilterRows(filteredRows);//Global filter function - IMP
    return filteredRows;
  }
  filteringDates() {
    let arr = [];
    const filters = this.filters;
    //debugger;

    for (const key in filters) {
      if (filters[key].type === DataType.Date) {
        return this.dates(filters[key]);
      }
    }
    return arr;
  }
  filteringDatesArr(dates) {
    let arr = [];
    //arr.push(dates);
    //arr.push(6);
    return arr;
  }

  globalFilterRows(data: any[]) {
    if (this.globalFilterValue) {
      return data.filter(item => Object.keys(item).map((key) => {
        return this.startsWith(item[key], this.globalFilterValue);
      }).includes(true));
    } else {
      return data;
    }
  }

  private dates(filter: FilterMeta) {
    //debugger;
    let arr = [];
    let filterValue;
    let filterValueTo;
    if (!isBlank(filter.value)) {
      filterValue = filter.value;//new Date(filter.value).setSeconds(0, 0);
      if (filterValue.indexOf('T') != -1)
        filterValue = formatDate(new Date(filterValue));
    }
    if (!isBlank(filter.valueTo)) {
      filterValueTo = filter.valueTo;//new Date(filter.valueTo).setSeconds(0, 0);
      if (filterValueTo.indexOf('T') != -1)
        filterValueTo = formatDate(new Date(filterValueTo));
    }
    switch (filter.matchMode) {
      case FilterOperator.EQUALS:
        arr = [];
        arr.push(filterValue + "^");
        arr.push(0);
        break;
      case FilterOperator.NOT_EQUAL:
        arr = [];
        arr.push(filterValue + "^");
        arr.push(1);
        break;
      case FilterOperator.IN_RANGE:
        arr = [];
        arr.push(filterValue + "^" + filterValueTo);
        arr.push(6);
        break;
      case FilterOperator.LESS_THAN:
        arr = [];
        arr.push("^" + filterValueTo);
        arr.push(2);
        break;
      case FilterOperator.LESS_THAN_OR_EQUAL:
        arr = [];
        arr.push("^" + filterValueTo);
        arr.push(3);
        break;
      case FilterOperator.GREATER_THAN:
        arr = [];
        arr.push(filterValue + "^");
        arr.push(4);
        break;
      case FilterOperator.GREATER_THAN_OR_EQUAL:
        arr = [];
        arr.push(filterValue + "^");
        arr.push(5);
        break;
      case FilterOperator.IS_EMPTY:
        arr = [];
        arr.push("");
        arr.push(12);
        break;
      case FilterOperator.IS_NOT_EMPTY:
        arr = [];
        arr.push("");
        arr.push(13);
        break;
      default:
        arr = [];
        arr.push(filterValue + "^");
        arr.push(0);
        break;
    }
    return arr;
  }
  
  //returns true or false
  private compare(value: any, filter: FilterMeta) {
    if (filter.type === DataType.Date) {
      //debugger;
      let filterValue;
      let filterValueTo;
      if (!isBlank(value)) {
        value = new Date(value);//.setSeconds(0, 0);
      }
      if (!isBlank(filter.value)) {
        filterValue = new Date(filter.value);//.setSeconds(0, 0);
      }
      if (!isBlank(filter.valueTo)) {
        filterValueTo = new Date(filter.valueTo);//.setSeconds(0, 0);
      }
      switch (filter.matchMode) {
        case FilterOperator.EQUALS:
          return this.dateEquals(value, filterValue);
        case FilterOperator.NOT_EQUAL:
          return !this.equals(value, filterValue);
        case FilterOperator.IN_RANGE:
          return this.inRange(value, filterValue, filterValueTo);
        case FilterOperator.LESS_THAN:
          return this.lessThan(value, filterValue);
        case FilterOperator.LESS_THAN_OR_EQUAL:
          return this.lessThanOrEqual(value, filterValue);
        case FilterOperator.GREATER_THAN:
          return this.greaterThan(value, filterValue);
        case FilterOperator.GREATER_THAN_OR_EQUAL:
          return this.greaterThanOrEqual(value, filterValue);
        case FilterOperator.IS_EMPTY:
          return isBlank(value);
        case FilterOperator.IS_NOT_EMPTY:
          return !isBlank(value);
        default:
          return this.dateEquals(value, filterValue);
      }
    } else {
      switch (filter.matchMode) {
        case FilterOperator.EQUALS:
          return this.equals(value, filter.value);
        case FilterOperator.NOT_EQUAL:
          return !this.equals(value, filter.value);
        case FilterOperator.IN_RANGE:
          return this.inRange(value, filter.value, filter.valueTo);
        case FilterOperator.IN:
          return this.in(value, filter.value);
        case FilterOperator.CONTAINS:
          return this.contains(value, filter.value);
        case FilterOperator.NOT_CONTAINS:
          return !this.contains(value, filter.value);
        case FilterOperator.STARTS_WITH:
          return this.startsWith(value, filter.value);
        case FilterOperator.ENDS_WITH:
          return this.endsWith(value, filter.value);
        case FilterOperator.LESS_THAN:
          return this.lessThan(value, filter.value);
        case FilterOperator.LESS_THAN_OR_EQUAL:
          return this.lessThanOrEqual(value, filter.value);
        case FilterOperator.GREATER_THAN:
          return this.greaterThan(value, filter.value);
        case FilterOperator.GREATER_THAN_OR_EQUAL:
          return this.greaterThanOrEqual(value, filter.value);
        case FilterOperator.IS_EMPTY:
          return isBlank(value);
        case FilterOperator.IS_NOT_EMPTY:
          return !isBlank(value);
        default:
          return this.equals(value, filter.value);
      }
    }
  }

  private equals(value, filter): boolean {
    if (isBlank(filter)) {
      return true;
    }
    if (isBlank(value)) {
      return false;
    }
    return value.toString().toLowerCase() === filter.toString().toLowerCase();
  }

  private in(value, filter: any[]): boolean {
    if (isBlank(filter)) {
      return true;
    }
    if (isBlank(value)) {
      return false;
    }
    if (!Array.isArray(filter)) {
      return value === filter;
    }
    return filter.some(x => x === value);
  }

  private startsWith(value, filter): boolean {
    if (isBlank(filter)) {
      return true;
    }
    if (isBlank(value)) {
      return false;
    }
    const filterValue = filter.toLowerCase();
    return value.toString().toLowerCase().slice(0, filterValue.length) === filterValue;
  }

  private endsWith(value, filter): boolean {
    if (isBlank(filter)) {
      return true;
    }
    if (isBlank(value)) {
      return false;
    }
    const filterValue = filter.toString().toLowerCase();
    return value.toString().toLowerCase().indexOf(filterValue, value.toString().length - filterValue.length) !== -1;
  }

  private contains(value, filter): boolean {
    if (isBlank(filter)) {
      return true;
    }
    if (isBlank(value)) {
      return false;
    }
    return value.toString().toLowerCase().indexOf(filter.toLowerCase()) !== -1;
  }

  private lessThan(value, filter): boolean {
    if (isBlank(filter)) {
      return true;
    }
    if (isBlank(value)) {
      return false;
    }
    return value < filter;
  }

  private lessThanOrEqual(value, filter): boolean {
    if (isBlank(filter)) {
      return true;
    }
    if (isBlank(value)) {
      return false;
    }
    return value <= filter;
  }

  private greaterThan(value, filter): boolean {
    if (isBlank(filter)) {
      return true;
    }
    if (isBlank(value)) {
      return false;
    }
    return value > filter;
  }

  private greaterThanOrEqual(value, filter): boolean {
    if (isBlank(filter)) {
      return true;
    }
    if (isBlank(value)) {
      return false;
    }
    return value >= filter;
  }

  private inRange(value, from, to): boolean {
    if (isBlank(from)) {
      //return this.lessThan(value, to);
      return this.lessThanOrEqual(value, to);
    }
    if (isBlank(to)) {
      //return this.greaterThan(value, from);
      return this.greaterThanOrEqual(value, from);
    }
    if (isBlank(value)) {
      return false;
    }
    //return value > from && value < to;
    return value >= from && value <= to;
  }

  private dateEquals(value, filter): boolean {
    if (isBlank(filter)) {
      return true;
    }
    if (isBlank(value)) {
      return false;
    }
    const dt1 = new Date(value);//.setSeconds(0, 0);
    const dt2 = new Date(filter);//.setSeconds(0, 0);
    return dt1 === dt2;
  }

  clear() {
    this.filters = {} as FilterMetadata;
    this.globalFilterValue = null;
  }

  hasFilter(columnName: string): boolean {
    return !isBlank(this.filters[columnName]);
  }

  hasFilters(): boolean {
    //return !(Object.keys(this.filters).length === 0 && this.filters.constructor === Object) || !isBlank(this.globalFilterValue);
    //console.log(Object.keys(this.filters).length)
    return !(Object.keys(this.filters).length <= 1 && this.filters.constructor === Object) || !isBlank(this.globalFilterValue);//ignore default timestamp col making length == 1
  }

  //IMP in filtering ind column
  setFilter(value: any, field: string, matchMode: string, valueTo?: any, dataType?: DataType, rsltType?: string, title?: string) {
    if (!isBlank(value) || !isBlank(valueTo)) {
      value = this.toNumberIfNumeric(value, dataType);
      valueTo = this.toNumberIfNumeric(valueTo, dataType);
      this.filters[field] = { value, matchMode, valueTo, type: dataType, rsltType, title };
    } else if (this.filters[field]) {
      delete this.filters[field];
    }
  }

  private toNumberIfNumeric(value: any, dataType?: DataType) {
    if (!isBlank(value) && dataType === DataType.Number && isNumeric(value)) {
      value = parseFloat(value);
    }
    return value;
  }

  getFilterValue(columnName: string) {
    //console.log(this.filters[columnName])
    return this.filters[columnName] ? this.filters[columnName].value : null;
  }

  getFilterValueTo(columnName: string) {
    return this.filters[columnName] ? this.filters[columnName].valueTo : null;
  }

  getFilterMatchMode(columnName: string) {
    return this.filters[columnName] ? this.filters[columnName].matchMode : null;
  }

  isNonValueFilter(matchMode: string) {
    return (matchMode === FilterOperator.IS_EMPTY || matchMode === FilterOperator.IS_NOT_EMPTY);
  }

  getProcessedFiltersArray(rsltType: string) {
    const filters = this.filters;
    let filtersArray: Array<GeneralFilter> = [];
    for (const key in filters) {
      if (filters[key]) {
        if (filters[key].rsltType.indexOf('|') != -1) {
          let rsltTypesArr = filters[key].rsltType.split('|');
          let boolRsltCheck = false;
          rsltTypesArr.forEach(function (value) {
            //if (key != "VQuad_Timestamp" && rsltTypeInAPICall(value) == rsltType) {
            if (rsltTypeInAPICall(value) == rsltType || rsltType == "ALL") {
              boolRsltCheck = true;
              return false;
            }
          });
          //console.log(boolRsltCheck)
          if (boolRsltCheck)
            filtersArray.push({ ColumnName: key, Operator: (this.getOperatorType(filters[key].matchMode))[0], Value: filters[key].value, ValueTo: filters[key].valueTo, LoggedInUserName: null, RsltType: filters[key].rsltType});
        }
        else {
          //if (key != "VQuad_Timestamp" && (filters[key].rsltType == "" || rsltTypeInAPICall(filters[key].rsltType) == rsltType)) {
          if (filters[key].rsltType == "" || rsltTypeInAPICall(filters[key].rsltType) == rsltType || rsltType == "ALL") {
            let newValue = filters[key].value;
            let newValueTo = filters[key].valueTo;
            if (key == "ASR_Ref" || key == "ASR_Deg") {
              newValue = parseFloat(newValue) / 100;
              if (newValueTo != null)
                newValueTo = parseInt(newValueTo) / 100;
            }
            filtersArray.push({ ColumnName: key, Operator: (this.getOperatorType(filters[key].matchMode))[0], Value: newValue, ValueTo: newValueTo, LoggedInUserName: null, RsltType: filters[key].rsltType })
          }
        }
      }
    }
    //console.log(filtersArray)
    return filtersArray;
  }
  getProcessedFilters(rsltType: string) {
    const filters: FilterMetadata = {} as FilterMetadata;
    //console.log(this.filters)
    for (const key in this.filters) {
      if (this.filters[key]) {
        if (this.filters[key].rsltType.indexOf('|') != -1) {//multiple rslt types having same column
          let rsltTypesArr = this.filters[key].rsltType.split('|');
          let boolRsltCheck = false;
          rsltTypesArr.forEach(function (value) {
            //if (key != "VQuad_Timestamp" && rsltTypeInAPICall(value) == rsltType) {
            if (rsltTypeInAPICall(value) == rsltType) {
              boolRsltCheck = true;
              return false;
            }
          });
          //console.log(boolRsltCheck)
          if (boolRsltCheck) {
            let value = this.filters[key].value;
            let matchMode = this.filters[key].matchMode;
            let valueTo = this.filters[key].valueTo;
            let type = this.filters[key].type;
            let rsltType = this.filters[key].rsltType;
            let title = this.filters[key].title;
            filters[key] = { value, matchMode, valueTo, type, rsltType, title };
          }
        }
        else {
          //if (key != "VQuad_Timestamp" && (filters[key].rsltType == "" || rsltTypeInAPICall(filters[key].rsltType) == rsltType)) {
          if (this.filters[key].rsltType == "" || rsltTypeInAPICall(this.filters[key].rsltType) == rsltType) {
            let value = this.filters[key].value;
            let matchMode = this.filters[key].matchMode;
            let valueTo = this.filters[key].valueTo;
            let type = this.filters[key].type;
            let rsltType = this.filters[key].rsltType;
            let title = this.filters[key].title;
            filters[key] = { value, matchMode, valueTo, type, rsltType, title };
          }
        }
      }
    }
    //console.log(filters)
    return filters;
  }
  replOldTSFilterWithNew() {
    for (const field in this.filters) {
      if (field.toLowerCase().indexOf('_timestamp') != -1) {
        delete this.filters[field];
        break;
      }
    }
  }
  getOperatorType(matchMode) {//(filter: FilterMeta) {
    let arr = [];
    //switch (filter.matchMode) {
    //Object.values(FilterOperator).forEach(x => console.log(x)) - IMP IMP
    //Object.keys(FilterOperator).forEach(x => console.log(x))
    switch (matchMode) {
      case FilterOperator.EQUALS:
        arr = [];
        arr.push(0)
        arr.push("Equals");
        break;
      //case RatingOperator.NOTUSE:
      //  arr = [];
      //  arr.push(0)
      //  arr.push("Not in use");
      //  break;
      case FilterOperator.NOT_EQUAL:
        arr = [];
        arr.push(1)
        arr.push("Not Equals");
        break;
      case FilterOperator.LESS_THAN:
        arr = [];
        arr.push(2)
        arr.push("Less than");
        break;
      case FilterOperator.LESS_THAN_OR_EQUAL:
        arr = [];
        arr.push(3)
        arr.push("Less than or equals");
        break;
      case FilterOperator.GREATER_THAN:
        arr = [];
        arr.push(4)
        arr.push("Greater than");
        break;
      case FilterOperator.GREATER_THAN_OR_EQUAL:
        arr = [];
        arr.push(5)
        arr.push("Greater than or equals");
        break;
      case FilterOperator.IN_RANGE:
        arr = [];
        arr.push(6)
        arr.push("In range of");
        break;
      case FilterOperator.IN:
        arr = [];
        arr.push(7)
        arr.push("In");
        break;
      case FilterOperator.CONTAINS:
        arr = [];
        arr.push(8)
        arr.push("Contains");
        break;
      case FilterOperator.NOT_CONTAINS:
        arr = [];
        arr.push(9)
        arr.push("Not contains");
        break;
      case FilterOperator.STARTS_WITH:
        arr = [];
        arr.push(10)
        arr.push("Starts with");
        break;
      case FilterOperator.ENDS_WITH:
        arr = [];
        arr.push(11)
        arr.push("Ends with");
        break;      
      case FilterOperator.IS_EMPTY:
        arr = [];
        arr.push(12)
        arr.push("Is empty");
        break;
      case FilterOperator.IS_NOT_EMPTY:
        arr = [];
        arr.push(13)
        arr.push("Is not empty");
        break;
      default:
        arr = [];
        arr.push(0)
        arr.push("Equals");
        break;
    }

    return arr;
  }
}
